




















































import Vue from "vue";
import userInfoProvider from "@/services/userInfoProvider";

import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  props: ["type", "list", "prepareFunc", "currentLoginType"],
  data() {
    return {
      userInfo: null,
      mfaType: ""
    };
  },
  methods: {
    convertName(mfa) {
      switch (mfa) {
        case "SmsOtp":
          return "SMS";
          break;
        case "EmailOtp":
          return "Email";
          break;
        case "Totp":
          return "Google Authenticator";
          break;
        case "SecurityKey":
          return "Security Key";
          break;
      }
    }
  }
});
